import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const rowWrapperFn = /* @__PURE__ */ createRecipe('row-wrapper', {}, [])

const rowWrapperVariantMap = {
  "gap": [
    "xxxs",
    "xxs",
    "xs",
    "s",
    "sm",
    "m",
    "ml",
    "l",
    "xl",
    "xxl"
  ]
}

const rowWrapperVariantKeys = Object.keys(rowWrapperVariantMap)

export const rowWrapper = /* @__PURE__ */ Object.assign(memo(rowWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'rowWrapper',
  __getCompoundVariantCss__: rowWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: rowWrapperVariantKeys,
  variantMap: rowWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, rowWrapperVariantKeys)
  },
  getVariantProps: rowWrapperFn.getVariantProps,
})